import {contextPath} from "site";
import {Http} from "@angular/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {OrgService} from "./shared/org.service";
import {AircraftSystemSummary} from "./aircraft-system-summary";

const apiURL = `${contextPath}/api/aircraft-systems/`;

@Injectable()
export class AircraftSystemService {
	constructor(private http: Http,
				private orgService: OrgService) {}

	getAircraftSystemSummary(customerAircraftUuid: string, systemUuid: string): Observable<AircraftSystemSummary> {
		return this.http.get(`${apiURL}${systemUuid}/summarize?aircraftUuid=${customerAircraftUuid}`, {headers: this.orgService.contextHeader})
			.map(response => AircraftSystemSummary.fromJSON(response.json()))
	}
}
